module.exports = ".actu .title {\n  background-color: #40c3bf;\n  color: white;\n  text-align: center;\n  padding: 3vh 0 3vh 0;\n  margin-bottom: 4vh;\n}\n.actu .title h1 {\n  font-size: 2.5rem;\n  font-weight: 700;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/actualite/_list/actualite.component.scss
// module id = ./src/app/actualite/_list/actualite.component.scss
// module chunks = main